import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import ShopNavbar from "../../StoreTemplate/StoreComponents/ShopNavbar";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { domainProvider } from "../../../contexts/DomainContext";
import axios from "axios";

const ResendEmail = () => {
  const storeName = window.location.pathname.split("/")[1];
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const selectLanguage = i18next.language;
  const { customdomain } = useContext(domainProvider);
  const { register, handleSubmit } = useForm();

  useEffect(() => {
    var user = localStorage.getItem("customer");
    user = JSON.parse(user);
    if (user?.data?.cust_id) {
      if (customdomain === "aitech.com.sa") navigate(`/${storeName}`);
      else navigate("/");
    }
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);

    const res = await axios.post(
      `${process.env.REACT_APP_APIURL}/vendor/store/customer/resendverificationmail`,
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const response = await res.data;
    setLoading(false);

    if (response.status_code === 200) {
      toast.info(response.email_message);
      if (customdomain === "aitech.com.sa")
        navigate(`/${storeName}/customer/verify-email`);
      else navigate(`/customer/verify-email`);
    } else {
      toast.error(response.err || response.email_message);
    }
  };

  return (
    <>
      <Helmet>
        <title>Resend Verify Email</title>
      </Helmet>
      <ShopNavbar />
      <section className="px-2 md:px-5 lg:px-20 py-5">
        <div className="container place-content-center mx-auto">
          <div className="registration-form max-w-md mx-auto  px-2 md:px-8">
            <form
              className="flex flex-col gap-y-4 card border shadow py-5 justify-center w-full"
              onSubmit={handleSubmit(onSubmit)}
            >
              <h2 className="text-center text-xl md:text-2xl mb-8">
                {t("Resend_verify_btn")}
              </h2>
              <div className="form-control w-full">
                <label className="label">
                  <span className="label-text">{t("l_email")}</span>
                </label>

                <input
                  {...register("customer_email", { required: true })}
                  type="email"
                  placeholder={t("l_phone_m")}
                  className="input input-sm input-bordered py-4 focus:outline-none rounded-none w-full "
                  required
                />
              </div>

              <div className="form-control w-full">
                <button
                  type="submit"
                  className={`btn cursor-pointer btn-primary text-white w-full  rounded-none ${
                    loading && "loading"
                  }`}
                >
                  {t("Resend Mail")}
                </button>
              </div>
            </form>

            <div className="flex flex-col w-full">
              <Link
                to={`${
                  customdomain === "aitech.com.sa"
                    ? `/${storeName}/register-login`
                    : `/register-login`
                }`}
                className="divider text-primary"
              >
                {selectLanguage === "ar"
                  ? "العودة إلى تسجيل الدخول"
                  : "Back to Login"}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResendEmail;
